import { Routes } from '@angular/router';
import { authenticationGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./features/de-tour/de-tour').then((m) => m.DeTour),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/landings/landings.routes').then((m) => m.landingsRoutes),
      },
      {
        path: 'cities',
        loadChildren: () => import('./features/cities/cities.routes').then((m) => m.citiesRoutes),
      },
      {
        path: 'routes',
        loadChildren: () => import('./features/routes/routes.routes').then((m) => m.routesRoutes),
      },
      {
        path: 'weathers',
        loadChildren: () => import('./features/routes/routes.routes').then((m) => m.routesRoutes),
      },
      {
        path: 'geomarker',
        loadChildren: () =>
          import('./features/geomarkers/geomarkers.routes').then((m) => m.geomarkersRoutes),
      },
      {
        path: 'contact',
        loadComponent: () => import('./features/contact/contact').then((m) => m.Contact),
      },
      {
        path: 'pages/404',
        loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
      },
      {
        path: 'pages/privacy-policies',
        loadChildren: () =>
          import('./features/privacy-policies/privacy-policies.routes').then(
            (m) => m.privacyRoutes,
          ),
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/user/pages/profile/profile').then((m) => m.Profile),
        canActivate: [authenticationGuard],
      },
      {
        path: 'search',
        loadComponent: () => import('./features/search/search').then((m) => m.Search),
      },
      // {
      //   path: 'booking',
      //   loadChildren: () =>
      //     import('./modules/booking/booking.module').then(
      //       (m) => m.BookingModule
      //     ),
      // },
      // {
      //   path: 'register-company',
      //   loadChildren: () =>
      //     import(
      //       './modules/user/register-company/register-company.module'
      //     ).then((m) => m.RegisterCompanyModule),
      // },
      // {
      //   path: 'dashboard',
      //   loadChildren: () =>
      //     import('./modules/dashboard/dashboard.module').then(
      //       (m) => m.DashboardModule
      //     ),
      // },
      // {
      //   path: 'checkout',
      //   loadChildren: () =>
      //     import('./modules/checkout/checkout.module').then(
      //       (m) => m.CheckoutModule
      //     ),
      // },
    ],
  },
  {
    path: '**',
    redirectTo: 'pages/404',
  },
];
